import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { ResponseObject } from 'src/app/models/response-object.model';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';

interface BatchDataResponse {
  // date: string;
  validationResults: any;
  // statusBatch: string;
  // batchId: string;
  records: any[];
}

export interface BamBatchStatus {
  code: string;
  name: string;
  description: string;
}

export const BAM_BATCH_STATUS_MAP: Record<string, BamBatchStatus> = {
  CN: { code: 'CN', name: 'CANCELADA', description: 'Lote finalizado' },
  IN: { code: 'IN', name: 'INGRESADO', description: 'Lote en ejecución' },
  VA: { code: 'VA', name: 'VALIDANDO', description: 'Lote en ejecución' },
  INVALID_BATCH: { code: 'LI', name: 'LOTE INVALIDO', description: 'Lote finalizado' },
  VD: { code: 'VD', name: 'VALIDADO', description: 'Lote en ejecución' },
  LE: { code: 'LE', name: 'LISTO PARA EJECUTAR', description: 'Lote en ejecución' },
  MI: { code: 'MI', name: 'METADATA INVALIDA', description: 'Lote finalizado' },
  EI: { code: 'EI', name: 'ESTADO INVALIDO', description: 'Lote finalizado' },
  EJ: { code: 'EJ', name: 'EJECUTADA', description: 'Lote finalizado' },
  ER: { code: 'ER', name: 'EJECUTADA CON ERRORES', description: 'Lote finalizado' },
  EE: { code: 'EE', name: 'EN EJECUCION', description: 'Lote en ejecución' },
  FD: { code: 'FD', name: 'FALLIDA', description: 'Lote finalizado' },
  PG: { code: 'PG', name: 'PROGRAMADA', description: 'Lote pendiente de ejecución' },
  RZ: { code: 'RZ', name: 'RECHAZADA', description: 'Lote finalizado' },
  VN: { code: 'VN', name: 'VENCIDA', description: 'Lote finalizado' }
};

export const BAM_BATCH_TYPE_MAP: Record<string, string> = {
  MONETARY: 'MONETARIA',
};

@Component({
  selector: 'app-view-favorite-batch',
  templateUrl: './view-favorite-batch.component.html',
  styleUrls: ['./view-favorite-batch.component.scss']
})
export class ViewFavoriteBatchComponent {
  @Input() batchId: any;
  @Input() accountNumber: any;
  @Output() closed = new EventEmitter<any>();
  loading: boolean = false;
  loadingVoucher: boolean = false;
  showModal: boolean = false;
  batchData: BatchDataResponse;

  constructor(private bamTransferServiceService: BamTransferServiceService,
    private toastrService: ToastrService) {

  }

  viewBatch() {
    if (this.batchId == null) {
      return
    }
    this.loading = true;
    this.bamTransferServiceService.getFavoriteBatchId(this.batchId).subscribe({
      next: (response: ResponseObject) => {
        this.batchData = response.data;
        this.loading = false;
        this.showModal = true;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener lote")
        this.loading = false;
        this.showModal = false;
      }
    });
  }

  getReceipts(batchTransaction: string, initDate: string, endDate: string, voucherNumber: string) {
    const data = {
      bankAccountNumber: this.accountNumber,
      initDate: this.formatDate(initDate),
      endDate: this.formatDate(endDate),
      batchTransaction: batchTransaction,
      operationList: [voucherNumber],
    }

    this.loadingVoucher = true;
    this.bamTransferServiceService.getReceipts(data).subscribe({
      next: (response) => {
        this.loadingVoucher = false;
        const blob = response.body!;

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'voucher.pdf';
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener lote")
        this.loadingVoucher = false;
      }
    });
  }

  status(code: string): BamBatchStatus | null {
    return BAM_BATCH_STATUS_MAP[code] || null;
  }

  statusType(code: string): string | null {
    return BAM_BATCH_TYPE_MAP[code] || null;
  }

  formatDate(dateStr: string): string {
    return dateStr.split('T')[0];
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(true);
    this.showModal = false;
  }

  closeModalEmit() {
    this.closed.emit(true);
    this.showModal = false;
  }
}

